var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBallotBox(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.7361,
    height: 58.10232,
    viewBox: "0 0 53.7361 58.10232",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3{fill:#d0cfce;}.cls-4,.cls-5,.cls-6,.cls-7{stroke-linecap:round;}.cls-4,.cls-5,.cls-7,.cls-3,.cls-8{stroke-width:2px;}.cls-4,.cls-7,.cls-8{stroke:#9b9b9a;}.cls-4,.cls-8{fill:#9b9b9a;}.cls-5,.cls-6{stroke:#000;}.cls-5,.cls-6,.cls-7{fill:none;}.cls-5,.cls-6,.cls-7,.cls-3,.cls-8{stroke-linejoin:round;}.cls-6{stroke-width:2.00013px;}.cls-3{stroke:#d0cfce;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1.0061,57.10232V25.15232H52.7361v31.95H1.0061Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52.2161,31.05232l-26.34,26.05h10.23l16.11-26.05"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.0361,
    y: 31.04233,
    width: 27.87,
    height: 3.752
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.9661,25.39232l16.17,5.836,9.927-22.72L24.68311,1.81332,14.9661,25.39232Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M36.10611,57.10232h16.62l-.5146-26.05-16.1054,26.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M12.8361,32.94232h28.18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "34.57193 25.14824 52.72212 25.14824 52.72212 55.09006"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1.00006,55.09006V25.14824H14.53458"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "28.1292 30.89381 14.64276 25.3646 24.63138 1.00006 41.3512 7.85146 31.97561 30.7135"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 12.7761,
    y1: 30.97232,
    x2: 40.9661,
    y2: 30.97232
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallotBox);
export default __webpack_public_path__ + "static/media/ballot-box.48522fe384ea998fd9e14e3d0d148c0a.svg";
export { ForwardRef as ReactComponent };